import { useEffect, useState } from "react";
import LoadingSpinner from "../../../basic/loadingSpinner/LoadingSpinner";
import { useBookSelectionVariant } from "../../../hooks/useBookSelectionVariant";
import { getBookCatalog } from "../../../networking/bookCatalog";
import SelectBookDropdowns from "../selectBookDropdowns/SelectBookDropdowns";
import SelectBookStepper from "../selectBookStepper/SelectBookStepper";

/** The book selection A/B test: the four-step selection against the old dropdowns. */
const SelectBookExperiment = () => {
    const variant = useBookSelectionVariant();
    const [hasCatalogFailed, setHasCatalogFailed] = useState(false);

    useEffect(() => {
        if (variant === "stepper") {
            // The stepper can't work without the catalog; the dropdowns load from p6u instead.
            getBookCatalog().catch(() => setHasCatalogFailed(true));
        }
    }, [variant]);

    if (!variant) {
        return (
            <div className="flex flex-1 items-center justify-center p-xl">
                <LoadingSpinner colorClass="border-p6-grey-lightest border-t-creation-primary" />
            </div>
        );
    }

    return variant === "stepper" && !hasCatalogFailed ? <SelectBookStepper /> : <SelectBookDropdowns />;
};

export default SelectBookExperiment;
